
export const genres =
    `Pop
Rock
Punk
Indie
Hip Hop
EDM
Country
Jazz
Classical
Roots`.split("\n").map(g => g.trim())

// copied directly out of the spreadsheet
// these match up to the genres above exctly in the right order
const spreadsheetGenreMixesRaw = `
80.00 	  80.00 	  90.00 
70.00 	  60.00 	  75.00 
40.00 	  45.00 	  30.00 
80.00 	  70.00 	  75.00 
80.00 	  80.00 	  90.00 
95.00 	  95.00 	  95.00 
20.00 	  20.00 	  20.00 
50.00 	  50.00 	  50.00 
30.00 	  10.00 	  20.00 
75.00 	  75.00 	  60.00 
`;

//debugger;

const spreadsheetGenreMixes = spreadsheetGenreMixesRaw
    .split("\n").map(g => g.trim()) // split lines
    .map(g => g.split("\t").map(g => g.trim())).filter(g => g.length == 3) // split each number
    .map((g, i) => ({
        genre: genres[i],
        streaming: parseFloat(g[0]),
        trackVsAlbum: parseFloat(g[1]),
        digitalVsPhysical: parseFloat(g[2]),
    }))

// export const spreadsheetGenreMixesLookup = makeLookup2(spreadsheetGenreMixes, g => g.genre, g => g);
export const spreadsheetGenreMixesLookup = new Map<string, typeof spreadsheetGenreMixes[number]>();
spreadsheetGenreMixes.forEach(g => spreadsheetGenreMixesLookup.set(g.genre, g));

// export const marketShareRatios = {
//     spotify: 0.80,
//     apple: 0.15,
//     google: 0.3,
//     others: 0.2,
// }

export const formats = ["Single", "Album"];
export const physicals = ["Yep, vinyl", "Yep, CDs", "A bit of both", "Nah"];


